<template>
  <div class="embed-session h-screen flex flex-col items-center justify-center px-6">
    <template v-if="error">
      <p class="text-danger text-center mb-4">{{ error }}</p>
      <vs-button @click="consume">Retry</vs-button>
    </template>
    <template v-else>
      <p class="text-center">Connecting to fleet tracking…</p>
    </template>
  </div>
</template>

<script>
import axios from '@/axios.js'
import { getDefaultHomePath } from '@/utils/accessRoutes'

export default {
  name: 'EmbedSession',
  data() {
    return {
      error: ''
    }
  },
  created() {
    this.consume()
  },
  methods: {
    ticketFromRoute() {
      const ticket = this.$route.query.ticket
      if (Array.isArray(ticket)) return ticket[0]
      return ticket
    },
    consume() {
      const self = this
      const ticket = this.ticketFromRoute()
      this.error = ''

      if (!ticket) {
        this.error = 'Missing embed ticket.'
        return
      }

      axios
        .get('/clients/embed-consume/' + encodeURIComponent(ticket))
        .then(function (response) {
          const data = response.data || {}
          const accessToken = data.accessToken || (data.userInfo && data.userInfo.accessToken)
          if (!data.userInfo || !accessToken) {
            self.error = 'Invalid embed session.'
            return
          }
          const payload = Object.assign({}, data, { accessToken: accessToken })
          self.$store.dispatch('auth/completeLoginFromTotp', payload)
          self.$acl.change(payload.userInfo.userRole)
          self.$router.replace(getDefaultHomePath(payload.userInfo)).catch(function (err) {
            console.log(err)
          })
        })
        .catch(function (err) {
          const msg =
            (err.response && err.response.data && err.response.data.error) ||
            'Unable to start tracking session.'
          self.error = msg
        })
    }
  }
}
</script>
